import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_warning_circle_red.svg'
import _imports_1 from '@/app/ui/assets/svg/warning-circle.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-5c0fde58")

_pushScopeId("data-v-5c0fde58")
const _hoisted_1 = { class: "w-full flex-col justify-between rounded border border-gray-lp-1300 shadow-outer" }
const _hoisted_2 = { class: "flex flex-row max-w-max whitespace-nowrap w-3/5 space-x-1" }
const _hoisted_3 = {
  class: "pl-5 pr-2 items-center bg-gray-lp-700 text-black-lp-300 text-12px font-semibold flex flex-row max-w-max whitespace-nowrap",
  style: {"border-top-left-radius":"0.25rem","padding-top":"1.5px","padding-bottom":"1.5px"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Terakhir diperbarui : ")
const _hoisted_5 = { class: "ml-2 font-normal" }
const _hoisted_6 = /*#__PURE__*/_createVNode("strong", null, "|", -1)
const _hoisted_7 = {
  key: 0,
  class: "px-2 py-0.5 bg-blue-lp-600 justify-center items-center gap-3 inline-flex truncate"
}
const _hoisted_8 = { class: "text-blue-lp-500 text-xs font-semibold truncate" }
const _hoisted_9 = { class: "pt-4" }
const _hoisted_10 = { class: "flex justify-between px-6 pb-4" }
const _hoisted_11 = { class: "w-full flex gap-8 items-center" }
const _hoisted_12 = { class: "capitalize text-sm text-gray-lp-600" }
const _hoisted_13 = { class: "flex flex-col text-12px text-center" }
const _hoisted_14 = {
  key: 0,
  class: "mx-8 text-12px font-normal font-montserrat"
}
const _hoisted_15 = {
  key: 0,
  class: "text-black-lp-300"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "w-1/6" }
const _hoisted_18 = { class: "flex flex-row items-center space-x-2" }
const _hoisted_19 = { class: "capitalize text-sm text-gray-lp-600" }
const _hoisted_20 = { class: "flex items-center gap-2" }
const _hoisted_21 = { class: "font-medium flex capitalize" }
const _hoisted_22 = { class: "flex flex-row items-center gap-2" }
const _hoisted_23 = { class: "font-medium flex capitalize" }
const _hoisted_24 = {
  key: 0,
  class: "relative"
}
const _hoisted_25 = { class: "flex justify-self-center gap-4" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "flex flex-row items-center px-2 bg-red-lp-1300 gap-x-2 max-w-max rounded-br-lg"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "exclamation",
  class: "h-4"
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("p", { class: "text-red-lp-100 font-normal text-14px" }, " Cut off time cycle sudah lewat. ", -1)
const _hoisted_33 = {
  key: 2,
  class: "flex flex-row items-center px-2 bg-yellow-lp-400 gap-x-2 max-w-max rounded-br-lg"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "exclamation",
  class: "h-4"
}, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("p", { class: "text-orange-lp-300 font-normal text-14px" }, " Cycle mendekati cut off time, segera booking sekarang! ", -1)
const _hoisted_36 = {
  key: 3,
  class: "w-full px-4 py-3"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-semibold font-montserrat text-gray-lp-300" }, " Estimasi keberangkatan ", -1)
const _hoisted_38 = { class: "text-14px font-normal font-montserrat mt-2" }
const _hoisted_39 = {
  key: 4,
  class: "flex flex-row mt-3 px-6 pb-4"
}
const _hoisted_40 = {
  key: 0,
  class: "w-1/4"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-semibold font-montserrat text-gray-lp-300" }, " Terbang Dalam ", -1)
const _hoisted_42 = { class: "bg-yellow-lp-200 px-2 rounded-xl text-14px text-yellow-lp-100 mt-2 inline-flex" }
const _hoisted_43 = { class: "pr-1" }
const _hoisted_44 = {
  key: 1,
  class: "w-1/4"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-semibold font-montserrat text-gray-lp-300" }, " Estimasi Keberangkatan ", -1)
const _hoisted_46 = { class: "text-14px font-normal font-montserrat mt-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")!
  const _component_LongArrow = _resolveComponent("LongArrow")!
  const _component_IconKoli = _resolveComponent("IconKoli")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("span", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.data.updatedAt)) + " ", 1),
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.onHandleName(_ctx.data.updateName)), 1)
        ])
      ]),
      (_ctx.data.clientParentName)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, " Klien : " + _toDisplayString(_ctx.data.clientParentName), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("div", null, [
            _createVNode(_component_Title, {
              label: _ctx.data.originCode
            }, null, 8, ["label"]),
            _createVNode("p", _hoisted_12, _toDisplayString(_ctx.data.originName), 1)
          ]),
          _createVNode("div", _hoisted_13, [
            (_ctx.isCargoPlane)
              ? (_openBlock(), _createBlock("div", _hoisted_14, [
                  (_ctx.data.flightsData.length > 1)
                    ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(_ctx.data.flightsData.length - 1) + "x Transit ", 1))
                    : _createCommentVNode("", true),
                  (_ctx.data.flightsData.length === 1)
                    ? (_openBlock(), _createBlock("span", _hoisted_16, "Langsung"))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock(_component_LongArrow, { key: 1 }))
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              _createVNode(_component_Title, {
                label: _ctx.data.destinationCode
              }, null, 8, ["label"])
            ]),
            _createVNode("p", _hoisted_19, _toDisplayString(_ctx.data.destinationName), 1)
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode(_component_IconKoli),
            _createVNode("div", _hoisted_21, _toDisplayString(_ctx.formatNumber(_ctx.data.totalPieces)) + " Koli ", 1)
          ]),
          _createVNode("div", _hoisted_22, [
            _createVNode(_component_Icons, {
              name: "weight-kg",
              class: "h-6 text-gray-lp-600"
            }),
            _createVNode("div", _hoisted_23, " Berat " + _toDisplayString(_ctx.formatNumber(_ctx.data.totalWeight)) + " Kg ", 1),
            (_ctx.data.status.toLowerCase().includes('belum'))
              ? (_openBlock(), _createBlock("div", _hoisted_24, [
                  _createVNode("img", {
                    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.data.isOpenTooltip = true)),
                    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.data.isOpenTooltip = false)),
                    src: require('@/app/ui/assets/svg/warning-circle.svg'),
                    alt: "tooltip-rtc",
                    class: "ml-2 cursor-pointer"
                  }, null, 40, ["src"]),
                  _withDirectives(_createVNode(_component_Tooltip, {
                    message: "Tambah STT atau bag agar mencapai minimum berat kargo (10kg)",
                    style: {"margin-top":"-80px"},
                    customClass: "pl-2",
                    isArrowLeft: false
                  }, null, 512), [
                    [_vShow, _ctx.data.isOpenTooltip]
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_25, [
          _createVNode(_component_LpButton, {
            outline: "",
            fontWeight: "semibold",
            icon: "icon-edit-dash",
            iconColor: "red-lp-100",
            color: "red-lp-100",
            onClick: _ctx.onEdit
          }, null, 8, ["onClick"]),
          (_ctx.isCargoPlane)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                (_ctx.data.cutOffTimeExceededWithoutNextConfig)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 0,
                      textColor: "white",
                      title: _ctx.$t('revamp.booking.selectSchedule'),
                      fontWeight: "semibold",
                      customClass: "w-48",
                      color: "red-lp-100",
                      onClick: _ctx.onBookingGenesis
                    }, null, 8, ["title", "onClick"]))
                  : (_openBlock(), _createBlock(_component_LpButton, {
                      key: 1,
                      textColor: "white",
                      title: _ctx.$t('revamp.booking.bookNow'),
                      fontWeight: "semibold",
                      customClass: "w-48",
                      color: "red-lp-100",
                      onClick: _ctx.onProcess
                    }, null, 8, ["title", "onClick"]))
              ], 64))
            : (_openBlock(), _createBlock("div", _hoisted_26, [
                _createVNode(_component_LpButton, {
                  onClick: _ctx.togglePanel,
                  icon: _ctx.iconTogglePanel,
                  sizeIcon: "16px",
                  fontWeight: "semibold",
                  title: _ctx.$t('revamp.booking.bookNow'),
                  customClass: "w-52",
                  textColor: "white"
                }, null, 8, ["onClick", "icon", "title"]),
                _createVNode(_component_OverlayPanel, {
                  ref: "op",
                  appendTo: "body",
                  style: {"width":"auto"}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_LpButton, {
                      class: "w-60",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createAndPrint(false))),
                      flat: "",
                      dense: "",
                      iconLeft: "cargo",
                      title: "Booking Kargo"
                    }),
                    _hoisted_27,
                    _createVNode(_component_LpButton, {
                      class: "w-full",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createAndPrint(true))),
                      flat: "",
                      dense: "",
                      iconLeft: "printer",
                      title: "Booking & Print PDF"
                    }),
                    _hoisted_28,
                    _createVNode(_component_LpButton, {
                      class: "w-full",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createAndPrint(false, true))),
                      flat: "",
                      dense: "",
                      iconLeft: "invoice-gray",
                      title: "Booking & Print Label"
                    })
                  ]),
                  _: 1
                }, 512)
              ]))
        ])
      ]),
      (_ctx.isCargoPlane || _ctx.data.isMoreThanCutOffTime)
        ? (_openBlock(), _createBlock("hr", _hoisted_29))
        : _createCommentVNode("", true),
      (_ctx.data.isMoreThanCutOffTime)
        ? (_openBlock(), _createBlock("div", _hoisted_30, [
            _hoisted_31,
            _hoisted_32
          ]))
        : _createCommentVNode("", true),
      (_ctx.data.isNearCutOffTime && _ctx.isCargoPlane)
        ? (_openBlock(), _createBlock("div", _hoisted_33, [
            _hoisted_34,
            _hoisted_35
          ]))
        : _createCommentVNode("", true),
      (_ctx.isCargoPlane && _ctx.data.cutOffTimeExceededWithNextConfig)
        ? (_openBlock(), _createBlock("div", _hoisted_36, [
            _hoisted_37,
            _createVNode("p", _hoisted_38, _toDisplayString(_ctx.estimationNextDeparture), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isCargoPlane && !_ctx.data.isMoreThanCutOffTime)
        ? (_openBlock(), _createBlock("div", _hoisted_39, [
            (_ctx.formatCalculateDiffTime && _ctx.isCargoPlane && !_ctx.data.isNearCutOffTime)
              ? (_openBlock(), _createBlock("div", _hoisted_40, [
                  _hoisted_41,
                  _createVNode("div", _hoisted_42, [
                    _createVNode("div", _hoisted_43, [
                      _createVNode(_component_Icons, {
                        name: "clock-cargo",
                        class: "w-4"
                      })
                    ]),
                    _createVNode("div", null, _toDisplayString(_ctx.formatCalculateDiffTime), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isCargoPlane && !_ctx.data.isMoreThanCutOffTime)
              ? (_openBlock(), _createBlock("div", _hoisted_44, [
                  _hoisted_45,
                  _createVNode("p", _hoisted_46, _toDisplayString(_ctx.onFormatDateEstimationDeparture), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})